var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:{'loader-wrapper': true, 'loader-overlay': _vm.overlay}},[_c('img',{attrs:{"src":require("@/assets/loading.svg")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('loading')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }